'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimilarItemsRemote = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItemsRemote = exports.SimilarItemsRemote = {
    fetchSimilarItems: function fetchSimilarItems(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            similarItemInfo = _ref.similarItemInfo;
        return new _promise2.default(function (resolve, reject) {
            var params = {
                boostFields: ['houseid:' + similarItemInfo.sellerId + '^2.5'],
                options: {
                    status: ['upcoming', 'live', 'online']
                },
                pageSize: 16,
                searchTerm: similarItemInfo.title
            };
            var encodedParams = encodeURIComponent((0, _stringify2.default)(params));
            var encodedIds = encodeURIComponent((0, _stringify2.default)(similarItemInfo.categoryIds));

            var request = (0, _helpers.makeGet)('<SEARCH-API>?ids=' + encodedIds + '&parameters=' + encodedParams, deployment, 'similaritems');
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/similarItems.js
// module id = QMRE
// module chunks = 57